import React, { useEffect, useState } from 'react';
import { LOGOUT } from 'ConstComponents';
import { useHistory } from 'react-router';
import { SelectActiveeKYC as SELECT_ACTIVE_EKYC } from 'Components/Api/eKYCSettingAPI';
import { Container } from '@material-ui/core';
import HOCLoader from 'Components/Loader/HOCLoader';
const CustomContainer = HOCLoader(Container);

export const KycIndex = () => {
    const history = useHistory();

    const [severity, setSeverity] = useState('success');
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);

    const selectActiveeKYC = async () => {
        const response = await SELECT_ACTIVE_EKYC();

        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            history.push('/KYC/Upload');
            setResponseMessage(response.data);
            setIsError(true);
        }
        let data = JSON.parse(response.data);
        // if (data.Name === 'InstantPay') {
        //     history.push('/InstantPayeKYC');
        //     return;
        // }
        if (data.Name === 'InstantPay') {
            history.push('/InstantPayVerification');
            return;
        } else if (data.Name === 'Paysprint') {
            history.push('/EkycPS');
            return;
        } else if (data.Name === 'PDRS') {
            history.push('/EkycPD');
            return;
        } else if (data.Name === 'Quick') {
            history.push('/EkycQU');
            return;
        } else if (data.Name === 'CashFree') {
            history.push('/EkycCF');
            return;
        } else {
            history.push('/KYC/Upload');
            return;
        }
    };

    useEffect(() => {
        selectActiveeKYC();
    }, []);

    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        ></CustomContainer>
    );
};
